import { createApp } from 'vue';
import PeopleWidgetVue from './people-widget.vue';
import { waitForBootstrap } from '../../bootstrap-helpers';

export class PeopleWidget {
    constructor(el, options) {
        this.props = options;
        this.init(el);
    }

    init(el) {
        const app = createApp(PeopleWidgetVue);
        _.forEach(this.props, (value, key) => app.provide(key, value));
        waitForBootstrap(() => app.mount(el));
    }
}